import { useEffect, useRef } from "react";
import { useAppSelector } from "../../services/hooks/useReduxHooks";
import styles from "./Slider.module.scss";

export const SliderComponent = (props: {
  offersTab?: boolean;
  children: React.ReactNode;
}) => {
  const { offersTab, children } = props;

  const sliderRef = useRef<HTMLDivElement>(null);

  const cartLoyaltyV2 = useAppSelector((state) => state.cartLoyaltyV2Reducer);

  const redeemedOffer = cartLoyaltyV2.cart.redeemedOffer;

  useEffect(() => {
    if (sliderRef.current) {
      const firstOffer = sliderRef.current.querySelector(`.${styles.slide}`);
      if (firstOffer) {
        firstOffer.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
    }
  }, [redeemedOffer?.id]);

  return (
    <div
      ref={sliderRef}
      className={`${styles.swiper_wrapper} ${offersTab && styles.offers_tab}`}
      data-test-id="offer_slider"
    >
      {children}
    </div>
  );
};
